///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.checkbooks = abcsetup.promos.checkbooks || {};
abcsetup.promos.checkbooks.supplier_deductions = abcsetup.promos.checkbooks.supplier_deductions || {};
abcsetup.promos.checkbooks.supplier_deductions.index = abcsetup.promos.checkbooks.supplier_deductions.index || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.checkbooks.supplier_deductions.index.table = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.checkbooks.supplier_deductions.index = {
    init: function () {
        abcsetup.setTitle('Manage Supplier Deductions');

        this._initDataTable();
        this._bindFormSubmit();
    },

    _initDataTable() {
        abcsetup.blockUI(true);
        const _this = this;
        const form = $('#supplier-deductions-form');
        let isInitialized = false;

        this.table = abcsetup.datatables.init($('table#supplier_deductions'), {
            bInfo: true,
            scroll_horizontal: true,
            responsive: false,
            iDisplayLength: 25,
            order: [[1, "asc"]],
            stateSave: false,
            serverSide: true,
            scrollX: true,
            scrollY: '75vh',
            resetTable: false,
            searchVisible: false, // Don't search hidden columns, unless 'searchable' is set

            ajax: {
                url: window.location.origin + "/api/promos/checkbooks/supplier_deductions/datatable",
                type: 'POST',
                beforeSend: function (xhr) {
                    if (!isInitialized) {
                        isInitialized = true;
                        return;
                    }

                    // Couldn't use abcsetup.alerts.confirm here because this has to be a synchronous operation and can't be done through promises or callbacks.
                    if (abcsetup.formDirtyChecker.isDirty(form) && !window.confirm('You have unsaved changes. This action will clear those. Do you want to continue?')) {
                        // When we abort the request, DataTable has already changed the page.
                        // The UI active class isn't added to the new page's button, but the button has been disabled.
                        // So, they can't click a page button, click cancel in the confirm dialog and then attempt to visit that page again (because that button was disabled).
                        // This next line allows them to attempt once more to visit that page (say, they changed their mind and don't care if they lose the changes they made).
                        _this.table.page($('#supplier-deductions-form .pagination > li.active > a').text() - 1);
                        return false;
                    }
                }
            },
            columns: [
                {name: 'name'},
                {name: 'vendor_id'},
                {name: 'checkbox', orderable: false, searchable: false},
            ],
        });

        this.table.on('draw', () => abcsetup.formDirtyChecker.takeSnapshot(form));
    },

    /**
     * Save changes to items on the current page.
     * @private
     */
    _bindFormSubmit() {
        const _this = this;

        $('#supplier-deductions-form').on('submit', function () {
            abcsetup.blockUI(true);
            abcsetup.formDirtyChecker.takeSnapshot(this);
            const formData = new FormData();
            $(this).serializeArray().forEach(field => {
                formData.append(field.name, field.value);
            });

            axios.post('/api/promos/checkbooks/supplier_deductions', formData)
                .then(() => {
                    _this.table.ajax.reload(); // Once this is done, the UI will be un-blocked.
                    abcsetup.alerts.flashMessage('Changes saved');
                });

            return false;
        });
    },
}
